/**
 * getUserId - Get or create persistent user ID for chat agent
 *
 * @param {string} deviceCode - Optional device code (P1, P2, A1, etc.) for device-specific chat
 * @returns {string} User ID unique to this device/browser session
 *
 * When deviceCode is provided, chat is scoped to that specific device.
 * Otherwise, uses localStorage to persist across sessions (shared per browser).
 */
export const getUserId = (deviceCode = null) => {
  // If device code provided, use device-specific ID (no localStorage needed)
  if (deviceCode) {
    const deviceUserId = `device-${deviceCode}`;
    console.log('🆔 Using device-specific user ID:', deviceUserId);
    return deviceUserId;
  }

  // Fallback: browser-based persistent ID
  const KEY = 'kuutio-chat-user-id';

  let userId = localStorage.getItem(KEY);

  if (!userId) {
    // Generate new persistent ID
    userId = `user-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem(KEY, userId);
    console.log('🆔 Created new user ID:', userId);
  }

  return userId;
};
